
import "/root/workspace/crm-pc_pGKl/src/components/HeaderDropdown/index.less?modules";
export default {"container": `container-czSo5JM1`}
